import { type FC, type ReactNode } from 'react'

import { LoginRegistrationLoginRenderSwitch } from './LoginRegistrationUserLoginRenderSwitch'

interface LoginRegistrationUserLoginContentProps {
  afterLoggedIn: (
    afterLoggedInSideEffectsWithPreferredLanguage: Promise<string | undefined>,
  ) => void
  children?: ReactNode
}

export const LoginRegistrationUserLoginContent: FC<
  LoginRegistrationUserLoginContentProps
> = ({ afterLoggedIn, children }) => {
  return (
    <LoginRegistrationLoginRenderSwitch afterLoggedIn={afterLoggedIn}>
      {children}
    </LoginRegistrationLoginRenderSwitch>
  )
}
